import React from 'react';
import { components } from 'react-select';

const Input = (props) => {
  const {
    selectProps: { onPaste },
  } = props;

  // @ts-ignore TS(2740): Type '{ onPaste: any; isHidden: false; selectProps... Remove this comment to see the full error message
  return <components.Input {...props} onPaste={onPaste} isHidden={false} />;
};

export default Input;
